import * as React from 'react';
import { Book } from '../../../types/Book';
import ReviewSlider from './ReviewSlider/ReviewSlider';
import './Inner.css';
import ReviewText from './ReviewText/ReviewText';
import Checkbox from '@material-ui/core/Checkbox/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel/FormControlLabel';
import Button from '../../Button/Button';
import Public from '@material-ui/icons/Public';
import IconButton from '@material-ui/core/IconButton';
import Close from '@material-ui/icons/Close';
import CheckIcon from '@material-ui/icons/CheckCircleOutline';
import { Review } from '../../../types/Review';

interface Props {
	book: Book;
	onSend: (mark: number, review: string, recommend?: boolean) => void;
	isLoading?: boolean;
	isSuccess?: boolean;
	onClose: () => void;
	isError?: boolean;
	review?: Review;
}

const MAX_SYMBOLS = 2000;

const Inner: React.FC<Props> = ({ book, onClose, onSend, isLoading, isSuccess, isError, review }) => {
	const [mark, setMark] = React.useState(review?.mark ? review.mark : 7);
	const [text, setText] = React.useState(review?.review ? review.review : '');
	const [recommend, setRecomment] = React.useState(review?.isRecommend);

	const onSendHandler = () => {
		onSend(mark, text, recommend);
	}

	return (
		<div className="review">
			<div className="review__header-popup">
				<div className="review__title">Ваше мнение</div>

				<IconButton className="review__header-close" onClick={onClose}>
					<Close />
				</IconButton>
			</div>

			{isSuccess && (
				<div className="review-success">
					<CheckIcon />

					<div>Ваш отзыв опубликован</div>
				</div>
			)}

			{!isSuccess && (
				<div>
					<div className="review__description">
						оставьте отзыв о книге {book.name}
					</div>

					<div className="review__header">Оценка</div>

					<div className="review__subheader">
						как бы вы оценили книгу от 1 до 10?
					</div>

					<ReviewSlider value={mark} onChange={setMark} />

					<div className="review__header">
						Ваш отзыв
						<div className="review__header__label">необязательно</div>
					</div>

					<div className="review__subheader">
						опишите свои впечатления от книги
					</div>

					<ReviewText
						onChange={setText}
						symbolsLeft={MAX_SYMBOLS - text.length}
						defaultText={text}
					/>

					<FormControlLabel
						control={
							<Checkbox
								classes={{
									root: "review__checkbox",
								}}
								checked={recommend}
								onChange={(e, checked) => setRecomment(checked)}
							/>
						}
						label="Рекомендую к прочтению"
						classes={{
							label: "review__recommend",
						}}
					/>

					{isError && <div className="review-error">
						Мы не смогли сохранить отзыв. Пожалуйста, попробуйте снова или обратитесь в нашу техническую поддержу	
					</div>}

					<div className="review__control">
						<div className="review__control__label">
							<Public />
							Ваша оценка будет видна остальным пользователям
						</div>

						<Button
							type="primary"
							onClick={onSendHandler}
							isLoading={isLoading}
						>
							Отправить
						</Button>
					</div>
				</div>
			)}
		</div>
	);
};

export default Inner;
